export default __webpack_public_path__ + "static/img-nhs-process--mobile-6e19a6f5368472800a2a015e2d1e4ce8.webp";